import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const DefectTrackingChart = ({ data }) => {
  return (
    <div className="p-4 md:p-6 rounded-xl border border-border bg-card mb-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground">Defect Tracking</h3>
          <p className="caption text-muted-foreground mt-1">Weekly defect distribution by type</p>
        </div>
      </div>
      
      <div className="w-full h-64 md:h-80" aria-label="Defect Tracking Bar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="week" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px',
                color: 'var(--color-foreground)'
              }}
            />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
            />
            <Bar dataKey="dimensional" fill="var(--color-primary)" name="Dimensional" />
            <Bar dataKey="surface" fill="var(--color-accent)" name="Surface" />
            <Bar dataKey="assembly" fill="var(--color-warning)" name="Assembly" />
            <Bar dataKey="functional" fill="var(--color-error)" name="Functional" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default DefectTrackingChart;